import './polyfills' // Must be first to fix production issues
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ConfigProvider } from 'antd'
import { QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from './contexts/AuthContext'
import { addSecurityMetaTags } from './middleware/securityHeaders'
import { initSentry } from './config/sentry'
import { queryClient } from './lib/queryClient'
import './i18n/config' // Initialize i18n
import App from './App.tsx'
import './index.css'

// Initialize Sentry error monitoring
initSentry()

// Apply security meta tags in development
if (import.meta.env.DEV) {
  addSecurityMetaTags()
}


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: '#1890ff',
              borderRadius: 6,
            },
          }}
        >
          <App />
        </ConfigProvider>
      </AuthProvider>
    </QueryClientProvider>
  </StrictMode>,
)